import React from "react";
import { FaLock, FaArrowLeft } from "react-icons/fa";

/**
 * Reusable Access Denied blocker component.
 * @param {string} moduleName  - Human-readable module name, e.g. "Purchase Bills"
 * @param {string} action      - Action that was blocked, e.g. "view", "delete"
 * @param {function} onBack    - Optional back handler
 */
const AccessDenied = ({ moduleName = "this page", action = "access", onBack }) => {
  const handleBack = () => {
    if (onBack) {
      onBack();
    } else {
      window.history.back();
    }
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "60vh",
        padding: "40px 20px",
        textAlign: "center",
      }}
    >
      <div
        style={{
          width: "80px",
          height: "80px",
          borderRadius: "50%",
          background: "linear-gradient(135deg, #fee2e2 0%, #fecaca 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          marginBottom: "24px",
          boxShadow: "0 4px 20px rgba(239, 68, 68, 0.2)",
        }}
      >
        <FaLock style={{ fontSize: "32px", color: "#dc2626" }} />
      </div>

      <h2
        style={{
          fontSize: "24px",
          fontWeight: "700",
          color: "#1e293b",
          marginBottom: "8px",
        }}
      >
        Access Denied
      </h2>

      <p
        style={{
          fontSize: "15px",
          color: "#64748b",
          maxWidth: "400px",
          lineHeight: "1.6",
          marginBottom: "32px",
        }}
      >
        You don't have permission to <strong>{action}</strong>{" "}
        <strong>{moduleName}</strong>. Please contact your administrator to
        request access.
      </p>

      <button
        onClick={handleBack}
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "8px",
          padding: "10px 20px",
          borderRadius: "10px",
          background: "#0284c7",
          color: "#fff",
          border: "none",
          fontWeight: "600",
          fontSize: "14px",
          cursor: "pointer",
        }}
      >
        <FaArrowLeft />
        Go Back
      </button>
    </div>
  );
};

export default AccessDenied;
